import React, { useEffect, useState } from "react";
import { Tabs, Tab } from "react-bootstrap";
import swal from "sweetalert";
import CountdownDisplay from "./../Dashboard/elements/CountdownDisplay";
import PredictionContent from "./PredictionsViewData";
import moment from "moment-timezone";
import axios from "axios";

export default function TaskSummaryBlog() {
  const currentYear = new Date().getFullYear();

  const [loading, setLoading] = useState(true);
  const [updateTrigger, setUpdateTrigger] = useState(false);
  const [countdown, setCountdown] = useState(null);
  const [flip, setFlip] = useState(false);

  const [predictionsByYear, setPredictionsByYear] = useState({});
  const [years, setYears] = useState([]);

  const [activeYear, setActiveYear] = useState(
    Number(localStorage.getItem("user_predictions_year")) || currentYear
  );

  const [userTimestamp, setUserTimestamp] = useState(Date.now());

  const groupNameLocal = localStorage.getItem("user_initial_Group");
  const groupName = groupNameLocal;

  const handleUpdateTrigger = () => {
    setUpdateTrigger((prev) => !prev);
  };

  const handleTabSelect = (selectedKey) => {
    const yearNumber = Number(selectedKey);
    setActiveYear(yearNumber);
    localStorage.setItem("user_predictions_year", String(yearNumber));
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);

        const encodedGroupName = encodeURIComponent(groupName);
        const response = await axios.get(
          `${process.env.REACT_APP_PREDICTIONS_API}/api/all-predictions/${encodedGroupName}?userTimestamp=${userTimestamp}`
        );

        const data = response.data || {};
        setPredictionsByYear(data);

        const fetchedYears = Object.keys(data)
          .map((y) => Number(y))
          .filter((y) => !Number.isNaN(y))
          .sort((a, b) => b - a);

        setYears(fetchedYears);

        if (!fetchedYears.includes(activeYear)) {
          if (fetchedYears.includes(currentYear)) {
            setActiveYear(currentYear);
            localStorage.setItem("user_predictions_year", String(currentYear));
          } else if (fetchedYears.length > 0) {
            setActiveYear(fetchedYears[0]);
            localStorage.setItem(
              "user_predictions_year",
              String(fetchedYears[0])
            );
          }
        }

        setLoading(false);
      } catch (error) {
        console.error("Error fetching predictions:", error);
        setLoading(false);
      }
    };

    fetchData();

    const calculateCountdown = () => {
      const userTz = moment.tz.guess();
      const currentYear = moment().year();
      // Target midnight January 1st of next year in user's local timezone
      const newYearDate = moment.tz(`${currentYear + 1}-01-01T00:00:00`, userTz);
      const userDateTime = moment.tz(userTz);
      const countdownDuration = moment.duration(newYearDate.diff(userDateTime));
      setCountdown(countdownDuration);
    };

    calculateCountdown();
    const countdownInterval = setInterval(calculateCountdown, 5000);

    return () => clearInterval(countdownInterval);
  }, [groupName, userTimestamp, updateTrigger]);

  const storedUserColor = localStorage.getItem("userDetails");
  const storedDetailsColor = storedUserColor
    ? JSON.parse(storedUserColor)
    : null;
  const storedRoleColor = storedDetailsColor?.data?.role || "";
  const storedUserId = storedDetailsColor?.data?.id;
  const bgCustom_Blue = storedRoleColor.includes("Admin")
    ? "#01152F"
    : "#01152F";

  return (
    <div className="container-fluid" style={{ backgroundColor: bgCustom_Blue }}>
      <div className="element-area">
        <div className="demo-view">
          <div className="container-fluid pt-0 ps-0 pe-lg-4 pe-0">
            {loading && years.length === 0 ? (
              <div style={{ color: "#fff" }}>Loading predictions…</div>
            ) : years.length === 0 ? (
              <div style={{ color: "#fff" }}>
                No prediction years found for this group.
              </div>
            ) : (
              <Tabs
                id="predictions-by-year-tabs"
                activeKey={String(activeYear)}
                onSelect={handleTabSelect}
              >
                {years.map((year) => {
                  const dataForYear = predictionsByYear[year];
                  const isFuture = year >= currentYear;
                  const isPast = year < currentYear;

                  return (
                    <Tab
                      key={year}
                      eventKey={String(year)}
                      title={String(year)}
                    >
                      <div style={{ height: "88vh", overflowY: "auto" }}>
                        {dataForYear ? (
                          <div>
                            <h3 style={{ color: "#F0E663" }}>
                              {isPast
                                ? "Predictions you made"
                                : "What do you predict?"}
                            </h3>
                            <PredictionContent
                              storedUserId={storedUserId}
                              predictionsData={dataForYear}
                              presentYear={year}
                              updateTrigger={updateTrigger}
                              setUpdateTrigger={handleUpdateTrigger}
                            />
                          </div>
                        ) : (
                          <div>
                            <h1>&nbsp;</h1>
                            <h1>&nbsp;</h1>
                            <h1>&nbsp;</h1>
                            <CountdownDisplay
                              countdown={countdown}
                              setCountdown={setCountdown}
                              flip={flip}
                              setFlip={setFlip}
                            />
                            <h1>&nbsp;</h1>
                            <h1>&nbsp;</h1>
                            {isFuture ? (
                              <h3 style={{ color: "#FF8888" }}>
                                You are a little early to the party, your Group
                                Admin will soon publish your group's questions.
                              </h3>
                            ) : (
                              <>
                                <h3 style={{ color: "#FF8888" }}>
                                  &nbsp;&nbsp;Please contact your group admin
                                </h3>
                                <h4 style={{ color: "#FFAAAA" }}>
                                  &nbsp;&nbsp;(no Predictions data found)
                                </h4>
                              </>
                            )}
                          </div>
                        )}
                      </div>
                    </Tab>
                  );
                })}
              </Tabs>
            )}
          </div>
          &nbsp;
        </div>
        &nbsp;
      </div>
      <h1>&nbsp;</h1>
    </div>
  );
}
